import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'chameleon/packages/blue-book-player/library/CheckBox';
import BlueBookButton from 'chameleon/packages/blue-book-player/library/bluebook-button/BlueBookButton';

const NotAvailableInBlueBookContent = (props) => {
  const { onCheckboxClick, onWarningAgree } = props;

  return (
    <>
      <h1 className="text-2xl font-semibold mt-0 mb-3">
        This feature exists in AP Classroom to support instruction throughout
        the year. It will not be available (and you will not need it) on your AP
        Exam.
      </h1>
      <div className="flex gap-[8px] items-center">
        <CheckBox onClick={onCheckboxClick} />
        <label className="flex items-center m-0">
          Do not show this message again
        </label>
        <BlueBookButton
          isPrimary
          size="small"
          className="ml-auto"
          onClick={onWarningAgree}
        >
          Ok
        </BlueBookButton>
      </div>
    </>
  );
};

NotAvailableInBlueBookContent.propTypes = {
  onCheckboxClick: PropTypes.func.isRequired,
  onWarningAgree: PropTypes.func.isRequired,
};

export default NotAvailableInBlueBookContent;
